/**
 * Main entry point for LIQUIDO mobile app.
 */
import config from "config"  // This path is automatically mapped to an environment specific config file config/config.<env>.json  See vite.config.js

console.log("===================")
console.log("WELCOME to LIQUIDO!")
console.log("===================")
console.log("config.source   = "+config.configSource)
console.log("LIQUIDO_API_URL = "+config.LIQUIDO_API_URL)

import { startApp } from "@/shared/shell/create-app.js"   // imports the global CSS first: Bootstrap, then liquido.css
import RootApp from '@/liquido/root-app.vue'
import router from '@/liquido/router.js'
import globalMessages from "@/shared/loc/global-messages.js"
import { store } from "@/liquido/services/store.js"
import { POLL_CARD_API } from "@/shared/components/poll-card-api.js"
import liquidoPollCardApi from "@/liquido/services/liquido-poll-card-api.js"
import { PAGE_FOOTER } from "@/shared/shell/page-footer.js"
import LiquidoFooter from "@/liquido/components/liquido-footer.vue"

//TODO: sanity check config for required attributes

startApp({
	rootComponent: RootApp,
	router,
	messages: globalMessages,              // the global catalogue, shared with Polly
	globalProperties: { $store: store },  // make store available in all components via this.$store
	provide: [
		[POLL_CARD_API, liquidoPollCardApi],   // what poll-card.vue needs from the team API
		[PAGE_FOOTER, LiquidoFooter],          // the footer of the shared legal pages
	],
})
